module.exports = __webpack_public_path__ + "static/img/tst2-02-1.78ec02b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-02-1.gif
// module id = 9mBG
// module chunks = 1